
import createError from "@/clir/utils/createError";
import getKey from "@/clir/utils/getKey";

const provider = process.env.VUE_APP_PROVIDER ? `${process.env.VUE_APP_PROVIDER}` : 'authDAC';

export default {
    DGFiPFetch: async ({ dispatch }, { url, options }) => {
        const optionsWithToken = { ...options };
        const headerWithToken = new Headers(options.headers);
        const authHeaders = await dispatch(`${provider}/getHeaders`, null, { root: true });
        Object.keys(authHeaders).forEach(key => {
            headerWithToken.set(key, authHeaders[`${key}`]);
        });
        optionsWithToken.headers = headerWithToken;
        return fetch(url, optionsWithToken)
        .then(async (res) => {
            if (!res.ok) {
                const contentType = res.headers.get("content-type");
                let body = '';
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    body = await res.json();
                }
                return Promise.reject({ res, ...body });
            }
            return res;
        }).then(response => {
            return response;
        }).catch(error => {
            const status = getKey(error.res, 'code', undefined) ||  getKey(error.res, 'status', 'xxx');
            const statusText = getKey(error, 'errorDescription', undefined) ||  getKey(error.res, 'statusText', 'Erreur inconnue');
            throw (createError({
                status,
                statusText }, 
                {
                    errorList: error.erreur || null,
                }
            ));
        });
    },
};